export default "/images/VeevaSalesRep.svg?ceaf663272715c5c0071cf6636ca51e3";